import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=c5ed0d44&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=c5ed0d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ed0d44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5ed0d44')) {
      api.createRecord('c5ed0d44', component.options)
    } else {
      api.reload('c5ed0d44', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=c5ed0d44&scoped=true&", function () {
      api.rerender('c5ed0d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z0c27ByoltyX/JS/comp/PopupDialog.vue"
export default component.exports